
angular.module('qkr').directive('formRecord', ['reportService', '$timeout', 'utils', 'appConfig',
    'gettextCatalog', 'formBuilderService', 'FormHelper', '$uibModal', 'messageService',
    function(reportService, $timeout, utils, appConfig, gettextCatalog,
              formBuilderService, FormHelper, $uibModal, messageService) {
        return {
            restrict: 'E',
            scope: {
                form: '=',
                arrCustomFields: '='
            },
            template: require('../../directives/forms/form_record.html'),
            replace: true,
            link(scope, element, attrs, controller) {
                setUp();

                // Handle date

                scope.eventDate = getEventDateStr();

                scope.openOptions = function() {
                    utils.scrollToTop();
                    scope.showOptions = true;
                };

                scope.generatePdf = function() {
                    if (scope.settings.reportWaiting || scope.form.numberOfSubmissions == 0) {
                        return;
                    }

                    scope.settings.reportWaiting = true;

                    const reportCommand = {
                        reportSpec: {
                            name: 'Report for ' + scope.form.name,
                            form: {
                                id: scope.form.id
                            },
                            sortOptions: scope.radioSelected.option

                        }
                    };

                    reportService.generateFormPdfReport(reportCommand).then((promise) => {
                        poll(promise.id, 'pdf', 'form');
                    });
                    utils.scrollToTop();
                };

                scope.view = function() {
                    utils.scrollToTop();
                    if (scope.form.numberOfSubmissions == 0) {
                        return;
                    }
                    window.location.href = 'storeFront#/forms/formView/' + scope.form.id;
                };

                scope.deleteForm = function() {
                    const confMsg = gettextCatalog.getString('Are you sure you want to permanently delete this form ' +
                        'and all its submissions? (note. the form will also be removed from the product)');

                    const modalInstance = $uibModal.open({
                        template: require('../../templates/common/modalDialog.html'),
                        controller: 'commonModalDialogController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return gettextCatalog.getString('Delete form');
                            },
                            confirmButtonName() {
                                return gettextCatalog.getString('Confirm');
                                return gettextCatalog.getString('Confirm');
                            },
                            confirmMsg() {
                                return confMsg;
                            },
                            multiMsgArray() {
                                return [];
                            }
                        }
                    });

                    modalInstance.result.then((result) => {
                        if (result == 'ok') {
                            formBuilderService.deleteForm(scope.form.id).then((response) => {
                                const formHelper = new FormHelper(scope);
                                const resp = formHelper.handleResponse(response);

                                if (resp.success) {
                                    $timeout(() => {
                                        scope.$emit('reloadForms');
                                    });
                                } else {
                                    messageService.error(gettextCatalog.getString('Error, form could not be deleted'));
                                }
                            });
                        }
                    }, () => {
                    });
                };

                function getEventDateStr() {
                    if (scope.form.expDateStr != null && scope.form.expDateStr.length > 0) {
                        return scope.form.expDateStr;
                    }
                    return 'N/A';
                }

                function poll(id, format, reportType) {
                    scope.timeoutPoll = $timeout(() => {
                        // Poll for report
                        reportService.pollReport(id)
                            .then((promise) => {
                                // Check if error on the report
                                if (promise.error) {
                                    handleGenerateReportError(promise);
                                } else if (promise.reportType == 'no-data') {
                                    scope.errors = {generate: gettextCatalog.getString('Error generating report')};
                                    scope.settings.reportWaiting = false;
                                }
                                // Check if complete, otherwise poll again
                                else if (promise.percentComplete == 100) {
                                    scope.errors = {};
                                    scope.settings.reportWaiting = false;
                                    scope.settings.reportUrl = appConfig.apiUrl + 'reportControl/' + promise.id + '/' + format;
                                    window.location.href = scope.settings.reportUrl;
                                } else {
                                    poll(id, format, reportType);
                                }
                            },
                            (error) => {
                                handleGenerateReportError(error);
                            });
                    }, 2500);
                }

                function handleGenerateReportError(error) {
                    let errors = {};

                    if (scope.errors) {
                        errors = scope.errors;
                    }

                    errors.generate = gettextCatalog.getString('Error generating report');
                    scope.errors = errors;
                    scope.settings.reportWaiting = false;
                }

                // When the DOM element is removed from the page, AngularJS will trigger the $destroy event on
                // The scope. This gives us a chance to cancel any pending timer that we may have.
                scope.$on(
                    '$destroy',
                    (event) => {
                        $timeout.cancel(scope.timeoutPoll);
                    }
                );

                function setUp() {
                    scope.errors = {};
                    scope.settings = {
                        reportWaiting: false,
                        reportUrl: ''
                    };

                    scope.radioSelected = {
                        option: 'Surname'
                    };
                }
            }
        };
    }]);



// WEBPACK FOOTER //
// ./src/directives/forms/form_record.js